<script setup lang="ts">
/**
 * Hint Source - message sous un champ (Text field / Select / Text area).
 * États alignés DS Enedis : default | error | success | warning.
 */
type HintState = 'default' | 'error' | 'success' | 'warning'

type Props = {
  text: string
  state?: HintState
  /** Id pour aria-describedby du champ associé. */
  hintId?: string
  /** role="alert" pour les erreurs (annonce lecteur d’écran). */
  alert?: boolean
}

withDefaults(defineProps<Props>(), {
  state: 'default',
  hintId: undefined,
  alert: false,
})
</script>

<template>
  <p
    v-if="text"
    :id="hintId"
    class="source-hint"
    :class="`source-hint--${state}`"
    :role="alert || state === 'error' ? 'alert' : undefined"
  >
    {{ text }}
  </p>
</template>

<style scoped lang="scss">
@use "~/assets/scss/partials/elpdl/colors" as c;

.source-hint {
  margin: 0;
  font-size: 12px;
  line-height: 1.333;
  color: var(--color-form-hint);

  &--error {
    color: var(--color-form-error-text);
  }

  &--success {
    color: c.$enedis-success-600;
  }

  &--warning {
    color: c.$enedis-warning-700;
  }
}
</style>
